import { render, staticRenderFns } from "./CatalogueHeader.vue?vue&type=template&id=7c05a2ac"
import script from "./CatalogueHeader.vue?vue&type=script&lang=js"
export * from "./CatalogueHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports